import { plumeMainnet as viemPlume } from 'viem/chains'

import type { AppChain } from './chain.types'

export const plume = {
  ...viemPlume,
  custom: {
    name: 'Plume Mainnet',
    shortName: 'Plume',
    morphoChainSlug: 'plume',
    blockExplorer: {
      baseUrl: 'https://phoenix-explorer.plumenetwork.xyz',
      name: 'Phoenix Explorer'
    },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x7420302Ddd469031Cd2282cd64225cCd46F581eA',
          startBlock: 765994n
        },
        MorphoBlue: { address: '0x42b18785CE0Aed7BF7Ca43a39471ED4C0A3e0bB5', startBlock: 765994n },
        MetaMorphoV11Factory: {
          address: '0x2525D453D9BA13921D5aB5D8c12F9202b0e19456',
          startBlock: 766078n
        }
      }
    }
  }
} as const satisfies AppChain<{ v1: true; v2: false }>
